import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10e859c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-main" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Poxa, houve um erro ao carregar o conteúdo.", -1))
const _hoisted_3 = {
  key: 1,
  class: "content-main__information"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContentHeader = _resolveComponent("ContentHeader")!
  const _component_ContentFallback = _resolveComponent("ContentFallback")!
  const _component_ContentControls = _resolveComponent("ContentControls")!
  const _component_TUIViewer = _resolveComponent("TUIViewer")!
  const _component_ContentComplements = _resolveComponent("ContentComplements")!
  const _component_ContentInteraction = _resolveComponent("ContentInteraction")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ContentHeader),
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.viewer.get(_ctx.currentContent?.type)), { class: "content-viewer" })),
    (!_ctx.currentContent)
      ? (_openBlock(), _createBlock(_component_ContentFallback, {
          key: 0,
          class: "content-viewer"
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_ContentControls),
    (
        _ctx.currentContent?.type !== _ctx.ContentType.EXERCISE &&
          _ctx.currentContent?.type !== _ctx.ContentType.SEARCHFORM
      )
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("h2", null, [
            _createVNode(_component_TUIViewer, {
              "model-value": _ctx.currentContent?.title
            }, null, 8, ["model-value"])
          ]),
          _createElementVNode("p", null, [
            _createVNode(_component_TUIViewer, {
              "model-value": _ctx.currentContent?.description
            }, null, 8, ["model-value"])
          ]),
          _createVNode(_component_ContentComplements),
          (_ctx.contentProvider?.getType() === _ctx.ContentProviderType.COURSE)
            ? (_openBlock(), _createBlock(_component_ContentInteraction, { key: 0 }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}